import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { User } from '../../models/user';

export class SetUser {
  static readonly type = '[Authentication] Set Auth Code';
  constructor(public user: User) {}
}

export class AuthenticationLogin {
  static readonly type = '[Authentication] Login';
  constructor(
    public user: User,
    public authCode: string
  ) {}
}

export class ClearAuthState {
  static readonly type = '[Authentication] Clear auth code';
  constructor() {}
}

export interface IAuthenticationState {
  user: User;
  authCode: string;
}

@State<IAuthenticationState>({
  name: 'authentication',
  defaults: {
    user: null,
    authCode: null
  }
})
@Injectable()
export class AuthenticationState {
  constructor() {}

  @Selector()
  static authCode(state: IAuthenticationState) {
    return state.authCode;
  }

  @Selector()
  static user(state: IAuthenticationState) {
    return state.user;
  }

  @Action(SetUser)
  setUser(ctx: StateContext<IAuthenticationState>, { user }: SetUser) {
    ctx.patchState({
      user: user
    });
  }

  @Action(AuthenticationLogin)
  authenticationLogin(ctx: StateContext<IAuthenticationState>, state: AuthenticationLogin) {
    ctx.setState(state);
  }

  @Action(ClearAuthState)
  clearAuthState(ctx: StateContext<IAuthenticationState>) {
    ctx.setState({
      authCode: null,
      user: null
    });
  }
}
